import React, {useState} from 'react';
import {css} from 'emotion';
import LayoutStep from '../LayoutStep';
import Input from '../../../common/material-easy-ui/input/Input';
import InputPassword from '../../../common/material-easy-ui/input/InputPassword';
import CguAccept from '../CguAccept';
import AvatarPicker from '../avatarPicker';
import {registerUser} from '../../../../redux/actions/userActions';
import {useDispatch, useSelector} from 'react-redux';

const StepOne = props => {
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [pseudo, setPseudo] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [avatar, setAvatar] = useState(0);
  const error_signin = useSelector(state => state.user.error_signin);

  /* ERROR STATE */
  const [error_firstName, setError_firstName] = useState(false);
  const [error_lastName, setError_lastName] = useState(false);
  const [error_pseudo, setError_pseudo] = useState(false);
  const [error_email, setError_email] = useState(false);
  const [error_password, setError_password] = useState(false);
  const [error_passwordConfirm, setError_passwordConfirm] = useState(false);
  const [isAccept, setIsAccept] = useState(false);

  const onChangeFirstName = e => {
    setFirstName(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1).toLowerCase());
  };
  const onChangeLastName = e => {
    setLastName(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1).toLowerCase());
  };
  const onChangePseudo = e => {
    setPseudo(e.target.value);
  };
  const onChangeEmail = e => {
    setEmail(e.target.value.toLowerCase());
  };
  const onChangePassword = e => {
    setPassword(e.target.value);
  };
  const onChangePasswordConfirm = e => {
    setPasswordConfirm(e.target.value);
  };

  const onChooseAvatar = item => setAvatar(item);
  const createUser = () =>
    dispatch(
      registerUser(firstName, lastName, pseudo, email, avatar, password),
    );

  const onAccept = () => {
    setIsAccept(!isAccept);
  };

  const onSignUp = () => {
    setError_email(false);
    setError_pseudo(false);
    setError_firstName(false);
    setError_password(false);
    setError_passwordConfirm(false);
    setError_lastName(false);

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var validForm = true;

    if (!re.test(email)) {
      validForm = false;
      setError_email({
        error: true,
        message: 'Veuillez saisir un mail valide',
      });
    }
    if (password == '') {
      setError_password({
        error: true,
        message: 'Veuillez saisir un mot de passe',
      });
      validForm = false;
    }
    if (passwordConfirm == '') {
      setError_passwordConfirm({
        error: true,
        message: 'Veuillez saisir un mot de passe de confirmation',
      });
      validForm = false;
    }
    if (firstName == '') {
      setError_firstName({
        error: true,
        message: 'Veuillez saisir votre prénom',
      });
      validForm = false;
    }
    if (lastName == '') {
      setError_lastName({error: true, message: 'Veuillez saisir votre Nom'});
      validForm = false;
    }
    if (pseudo == '') {
      setError_pseudo({error: true, message: 'Veuillez saisir un pseudo'});
      validForm = false;
    }
    if (password !== passwordConfirm) {
      setError_passwordConfirm({
        error: true,
        message: "Votre mot de passe de confirmation n'est pas valide",
      });
      validForm = false;
    }
    if (validForm == true) createUser();
  };

  return (
    <LayoutStep>
      <div
        className={css`
          font-size: 14px;
          color: #525252;
          font-weight: 600;
        `}>
        PRESENTEZ VOUS
      </div>
      <Input
        error={error_firstName}
        style={{
          height: 40,
          marginTop: 20,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          alignItems: 'center',
          paddingTop: 5,
          paddingBottom: 5,
        }}
        inputStyle={{fontSize: 15}}
        labelStyle={{color: '#cccccc'}}
        onChangeText={onChangeFirstName}
        placeholder={'Prénom'}
        text={firstName}
      />
      <Input
        error={error_lastName}
        style={{
          height: 40,
          marginTop: 20,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          alignItems: 'center',
          paddingTop: 5,
          paddingBottom: 5,
        }}
        inputStyle={{fontSize: 15}}
        labelStyle={{color: '#cccccc'}}
        onChangeText={onChangeLastName}
        placeholder={'Nom'}
        text={lastName}
      />
      <Input
        error={error_pseudo}
        style={{
          height: 40,
          marginTop: 20,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          alignItems: 'center',
          paddingTop: 5,
          paddingBottom: 5,
        }}
        inputStyle={{fontSize: 15}}
        labelStyle={{color: '#cccccc'}}
        onChangeText={onChangePseudo}
        placeholder={'Pseudo'}
        text={pseudo}
      />

      <div
        className={css`
          font-size: 14px;
          color: #525252;
          font-weight: 600;
          margin-top: 20px;
        `}>
        CHOISISSEZ VOTRE AVATAR
      </div>
      <AvatarPicker avatarChoose={avatar} onChooseAvatar={onChooseAvatar} />
      <div
        className={css`
          font-size: 14px;
          color: #525252;
          font-weight: 600;
          margin-top: 20px;
        `}>
        RENSEIGNEZ VOS IDENTIFIANTS
      </div>
      <Input
        error={error_email}
        style={{
          height: 40,
          marginTop: 20,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          alignItems: 'center',
          paddingTop: 5,
          paddingBottom: 5,
        }}
        inputStyle={{fontSize: 15}}
        labelStyle={{color: '#cccccc'}}
        onChangeText={onChangeEmail}
        placeholder={'Email'}
        text={email}
      />
      <InputPassword
        error={error_password}
        style={{
          height: 40,
          marginTop: 20,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          alignItems: 'center',
          paddingTop: 5,
          paddingBottom: 5,
        }}
        inputStyle={{fontSize: 15}}
        labelStyle={{color: '#cccccc'}}
        onChange={onChangePassword}
        placeholder={'Mot de passe'}
        text={password}
      />

      <InputPassword
        error={error_passwordConfirm}
        style={{
          height: 40,
          marginTop: 20,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          alignItems: 'center',
          paddingTop: 5,
          paddingBottom: 5,
        }}
        inputStyle={{fontSize: 15}}
        labelStyle={{color: '#cccccc'}}
        onChange={onChangePasswordConfirm}
        placeholder={'Confirmation de mot de passe'}
        text={passwordConfirm}
      />
      <CguAccept value={isAccept} onAccept={onAccept} />
      <div
        onClick={() => {
          isAccept && onSignUp();
        }}
        className={css`
          background-color: ${isAccept ? '#0084C6' : 'grey'};
          color: white;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 10px;
          margin-top: 30px;
        `}>
        Envoyer
      </div>
      <div
        className={css`
          height: 50px;
        `}
      />
    </LayoutStep>
  );
};
export default StepOne;
